import { UserNotes } from './user-notes.model';

// TODO: user record
export class UserNotesWrapper {
  danger?: UserNotes[];
  info?: UserNotes[];
  success?: UserNotes[];
  custom?: UserNotes[];
}
